import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { http } from "../lib/api";
import Shop from "./Shop";

export default function CategoryPage() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  useEffect(() => { http.get(`/categories/${slug}`).then((r) => setCat(r.data)).catch(() => setCat(false)); }, [slug]);

  return (
    <div>
      <section className="relative h-[42vh] bg-zinc-950 overflow-hidden flex items-end">
        {cat?.banner && <img src={cat.banner} alt={cat.name} className="absolute inset-0 w-full h-full object-cover opacity-70" />}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="relative p-6 sm:p-12 max-w-3xl">
          <h1 className="font-display text-5xl sm:text-7xl text-white uppercase tracking-tight">{cat?.name || "Category"}</h1>
          {cat?.description && <p className="text-zinc-300 mt-3 max-w-lg text-sm">{cat.description}</p>}
        </div>
      </section>
      <Shop key={slug} title="" fixedCategory={slug} hideFilters />
    </div>
  );
}
